import dayjs from 'dayjs';
import { CheckOutlined, CloseOutlined } from '@mui/icons-material';

import { CustomAccordion, Text } from '../../shared/uiComponents';
import { InfoRow as Row } from '../StyledComponents';

import { UserProperties } from '../../redux/API/userAPIProperties';
import { UserRegistrationInfoProperties } from '../../redux/API/identityAPIProperties';
import { AdminTypes } from '../Menu';

const UserInfo = ({
	accountInfo,
	userInfo,
}: {
	accountInfo: UserRegistrationInfoProperties;
	userInfo: UserProperties;
}) => {
	const { email, previousEmail, lastConfirmationEmailSendDate, lastEmailChangedDate, lastPasswordChangedDate } =
		accountInfo;

	const { fullName, phoneNumber, address, authorizationType, createdBy, role, isCaseCoordinator, mbhId } = userInfo;

	return (
		<CustomAccordion
			headerStyle={{ padding: 0 }}
			HeaderContent={() => (
				<Row>
					<Text type="psm" fontWeight="semiBold" title="Name:" />
					<Text title={fullName} />
				</Row>
			)}
			Content={() => (
				<div style={{ padding: '0px 8px' }}>
					{Boolean(phoneNumber) && (
						<Row>
							<Text title="Phone Number: " type="psm" fontWeight="semiBold" />
							<Text title={phoneNumber} />
						</Row>
					)}
					<Row>
						<Text title="Email: " type="psm" fontWeight="semiBold" />
						<Text title={email} />
					</Row>
					{Boolean(previousEmail) && (
						<Row>
							<Text title="Previous Email: " type="psm" fontWeight="semiBold" />
							<Text title={previousEmail} />
						</Row>
					)}
					{Boolean(lastEmailChangedDate) && (
						<Row>
							<Text title="Last Email Change Date: " type="psm" fontWeight="semiBold" />
							<Text title={dayjs(lastEmailChangedDate).format('MM/DD/YYYY hh:mm A')} />
						</Row>
					)}
					<Row>
						<Text title="Address: " type="psm" fontWeight="semiBold" />
						<Text title={address} />
					</Row>
					{authorizationType?.id === 1 && (
						<Row>
							<Text title="Authorization Type: " type="psm" fontWeight="semiBold" />
							<Text title={authorizationType?.name ?? '-'} />
						</Row>
					)}
					<Row>
						<Text title="Role: " type="psm" fontWeight="semiBold" />
						<Text title={role.name} />
					</Row>
					<Row>
						<Text title="Section: " type="psm" fontWeight="semiBold" />
						<Text title={role.section.name} />
					</Row>
					<Row>
						<Text title="Created by: " type="psm" fontWeight="semiBold" />
						<Text title={createdBy.fullName} />
					</Row>
					{lastConfirmationEmailSendDate && (
						<Row>
							<Text title="Recent Resend Date:" type="psm" fontWeight="semiBold" />
							<Text title={dayjs(lastConfirmationEmailSendDate).format('MM/DD/YYYY hh:mm A')} />
						</Row>
					)}
					{lastPasswordChangedDate && (
						<Row>
							<Text title="Last Password Change Date:" type="psm" fontWeight="semiBold" />
							<Text title={dayjs(lastPasswordChangedDate).format('MM/DD/YYYY')} />
						</Row>
					)}
					{role?.section.id === AdminTypes.admin && (
						<Row>
							<Text title="Case Manager:" type="psm" fontWeight="semiBold" />
							<div>{isCaseCoordinator ? <CheckOutlined fontSize="small" /> : <CloseOutlined fontSize="small" />}</div>
						</Row>
					)}
					<Row>
						<Text title="MBH Id: " type="psm" fontWeight="semiBold" />
						<Text title={mbhId} />
					</Row>
				</div>
			)}
		/>
	);
};

export default UserInfo;
